exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".start-card {\n    border-right: 1px solid #cccccc;\n    padding: 24px;\n    background-color: white;\n    height: 100%;\n}\n\n.row-fill-height {\n    height: 100%;\n}\n\n.row-margin {\n    margin-left: 24px;\n}\n\n.column-fill-height {\n    height: 100%;\n}\n\n.my-card-img {\n    background-image: url(" + require("../../../images/harbor-logo.png") + ");\n    background-repeat: no-repeat;\n    background-size: contain;\n    height: 160px;\n}\n\n.my-card-footer {\n    float: right;\n    margin-top: 100px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/base/start-page/start.component.css
// module id = 814
// module chunks = 0